import { BaseModel } from '../../_base/crud';

// tslint:disable:variable-name
export class PatientInsuranceModel extends BaseModel {
  id: number;
  insurance_id: number;
  insurance_no: number;
  group_no: number;
  person_code: number;
  issue_date: any;
  expire_date: any;
  is_active: boolean;
  relation: any;
  priority: any;
  insurance: any;

  clear() {
    this.id = 0;
    this.insurance_id = 0;
    this.insurance_no = 0;
    this.group_no = 0;
    this.person_code = 0;
    this.issue_date = null;
    this.expire_date = null;
    this.group_no = 0;
    this.relation = null;
    this.priority = null;
    this.is_active = false;
    this.insurance = null;
  }
}
